<template>
    <v-card>
        <v-card-title>{{$t('event.colors')}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-form ref="form"
                        v-model="isFormValid">
                        <v-row v-for="color in colors" :key="color">
                            <ColorPickerInput v-model="eventColor[color]"
                                            :label="$t('event_color.'+color)"
                                            :rules="requiredRules"></ColorPickerInput>
                        </v-row>
                        <v-row>
                            <v-btn color="primary" @click="saveEventColor" :disabled="!isFormValid">
                                {{$t('save')}}
                            </v-btn>
                        </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import {computed, ref} from '@vue/composition-api'
    import {useGet} from "feathers-vuex";
    import ColorPickerInput from "../../components/ColorPickerInput";

    export default {
        name: 'EventColor',
        components: {ColorPickerInput},
        setup(props, {root}) {
            const {Event} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);
            const {item: event, isPending} = useGet({model: Event, id: eventId});

            const eventColor = computed(() => {
                return event.value ? event.value.events_color : null;
            });

            const colors = ref([
                "primary",
                "primaryLight",
                "primaryDarker",
                "background",
                "menuBG",
                "menuText",
                "menuIcon",
                "menuTintBG",
                "menuTint",
                "menuTintIcon",
                "statusBG",
            ]);

            const requiredRules = ref([
                value => !!value || 'Required',
            ]);

            const isFormValid = ref(false);

            const saveEventColor = function () {
                eventColor.value.save().then(() => {
                    root.$store.dispatch('showSnackBar', root.$t('event_color.save_successful'));
                }, root.$handleFeatherError.bind(root));
            };

            return {
                eventColor,
                colors,
                requiredRules,
                isFormValid,
                saveEventColor,
            }
        },
    }
</script>